import { Component, OnInit, forwardRef, Input, ViewChild } from '@angular/core';
import { 
    
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { DemoozButtonComponent, DemoozMessageComponent, DemoozModalComponent } from '@demooz/components';
import { DemonstrationsItemComponent, DemonstrationsValidationCodeComponent } from '@app/components';
import { DataService } from '@app/services';

@Component({
    selector: 'app-demonstrations-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        TranslatePipe, forwardRef(() => DemoozButtonComponent), forwardRef(() => DemoozMessageComponent), forwardRef(() => DemoozModalComponent), 
        forwardRef(() => DemonstrationsItemComponent), forwardRef(() => DemonstrationsValidationCodeComponent)
    ]
})
export class DemonstrationsListComponent  implements OnInit {
      
    @ViewChild('modalValidationCode') modalValidationCode: DemoozModalComponent;
      
    matches: Array<any> = [];
    matchesArchived: Array<any> = [];
    maxMatchesDisplayed: number = 3;
    nbMatchesPreview: number = 4;
    showBtnShareDemo: boolean = false;
   
    constructor(             
        public dataService: DataService
    ) { }

    ngOnInit() {
        let isShareSupported = (typeof navigator.share === 'function');
        this.maxMatchesDisplayed = 3;
        this.matches = this.dataService.ambassador.matchesActives;
        this.matchesArchived = this.dataService.ambassador.matchesArchived;
        this.showBtnShareDemo = isShareSupported
            && this.dataService.operation.demonstrationsContent?.isShareButtonVisible;
    }
    
    openModalValidationCode(){
        this.modalValidationCode.open();
    }
    
    onValidationCode(status: boolean){
        if(status){
            this.matches = this.dataService.ambassador.matchesActives;
            this.modalValidationCode.dismiss();
        }
    }
    
    seeAllDemonstrations(){
        this.maxMatchesDisplayed = this.matches.length;
    }
        
    async shareLinkDemonstration(){
        let urlWidget = this.dataService.widget.value?.url;
        if(urlWidget){
            let shareData = {
                title: ' ',
                text: '',
                url:  urlWidget + (urlWidget.indexOf('?') !== -1 ? '&' : '?') + 'a=' + this.dataService.ambassador.value?.ID
            };
            await navigator.share(shareData);
        }
    }
}
